export const UPDATE_HISTORY_NAVIGATION =
  '@historyNavigation/update-history-navigation';

export function setHistoryNavigation(url) {
  return {
    type: UPDATE_HISTORY_NAVIGATION,
    payload: url,
  };
}
